import { CommonModule } from '@angular/common';
import { NgModule, ModuleWithProviders } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { GlobalModule } from '@argalis-apps/angular-global';
import { ContextMenuModule } from '@progress/kendo-angular-menu';
import { WpRouting } from './wp-routing';
import { NavigationMenuComponent } from './components/navigation-menu/navigation-menu.component';
import { WpConfigServiceOption, WpConfigService } from './services/wp-config/wp-config.service';

@NgModule({
  declarations: [NavigationMenuComponent],
  imports: [CommonModule, GlobalModule, RouterModule, ContextMenuModule],
  providers: [WpConfigService],
  exports: [NavigationMenuComponent]
})
export class WpModule {
  public static moduleRouting(config?: WpConfigServiceOption): Routes {
    return WpRouting;
  }
  public static forRoot(config?: WpConfigServiceOption): ModuleWithProviders<WpModule> {
    return {
      ngModule: WpModule,
      providers: [
        WpConfigService,
        {
          provide: WpConfigServiceOption,
          useValue: config
        }
      ]
    };
  }
}
